import { render } from "./ServicesFour.vue?vue&type=template&id=33d15851"
import script from "./ServicesFour.vue?vue&type=script&lang=js"
export * from "./ServicesFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__